import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  cartaServicos: []
});

function cartaServicosReducer(state = initialState, action) {
  switch (action.type) {
    case types.CARTA_SERVICOS_LIST_START: {
      return startLoad(state);
    }

    case types.CARTA_SERVICOS_LIST_SUCCESS: {
      return endLoad(state.set('cartaServicos', fromJS(action.payload)));
    }

    case types.CARTA_SERVICOS_LIST_ERROR: {
      return endLoad(state);
    }
  }

  return state;
}

export default cartaServicosReducer;
